import React, { useState } from "react";
import "./FormCompra.css";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function CheckoutForm() {

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const kit = params.get("kit");
  const preco = params.get("preco");
  const description = params.get("description");

  const [compraId] = useState(
    "pedido_" + Date.now() + "_" + Math.floor(Math.random()*100000)
  );

  const [loadingCep,setLoadingCep] = useState(false);
  const [submitting,setSubmitting] = useState(false);
  const [error,setError] = useState("");

  const [form,setForm] = useState({
    nome:"",
    celular:"",
    email:"",
    cpf:"",
    cep:"",
    endereco:"",
    numero:"",
    bairro:"",
    cidade:"",
    estado:""
  });

  const estados = [
    "AC","AL","AP","AM","BA","CE","DF","ES","GO",
    "MA","MT","MS","MG","PA","PB","PR","PE","PI",
    "RJ","RN","RS","RO","RR","SC","SP","SE","TO"
  ];

  const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzRpTEbdM6dzZwK7v_48aEJjNVivn-auestSaWDHNebj8kI73yW2CE9aZMihb8Wt-_g/exec";

  const CLOUD_RUN_URL =
  "https://gerador-pagamentos-mercadopago-288487630160.us-east1.run.app";

  function mascaraCEP(v){
    v=v.replace(/\D/g,'');
    v=v.replace(/^(\d{5})(\d)/,"$1-$2");
    return v.slice(0,9);
  }

  function mascaraCPF(v){
    v=v.replace(/\D/g,'');
    v=v.replace(/(\d{3})(\d)/,"$1.$2");
    v=v.replace(/(\d{3})(\d)/,"$1.$2");
    v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
    return v.slice(0,14);
  }

  function mascaraCelular(v){
    v=v.replace(/\D/g,'');
    v=v.replace(/^(\d{2})(\d)/g,"($1) $2");
    v=v.replace(/(\d{5})(\d)/,"$1-$2");
    return v.slice(0,15);
  }

  const buscarCEP = async (cep) => {

    const cepLimpo = cep.replace(/\D/g,'');

    if(cepLimpo.length!==8) return;

    setLoadingCep(true);

    try{

      const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await res.json();

      if(!data.erro){

        setForm(prev => ({
          ...prev,
          cep:mascaraCEP(cepLimpo),
          endereco:data.logradouro || "",
          bairro:data.bairro || "",
          cidade:data.localidade || "",
          estado:data.uf || ""
        }));

      }

    }catch(e){}

    setLoadingCep(false);
  }

  function handleChange(e){

    let {name,value} = e.target;

    if(name==="cep"){
      value=mascaraCEP(value);
      buscarCEP(value);
    }

    if(name==="cpf") value=mascaraCPF(value);
    if(name==="celular") value=mascaraCelular(value);

    setForm(prev => ({
      ...prev,
      [name]:value
    }));

  }

async function handleSubmit(){

  if(submitting) return;

  if(form.celular.replace(/\D/g,'').length!==11){
    setError("Informe um celular válido com DDD, ex.: (19) 99999-1111.");
    return;
  }

  setError("");
  setSubmitting(true);

  try {

    const payload = {
      ...form,
      compra_id: compraId,
      kit: kit,
      preco: preco,
      description: description,
      new_sell: true
    };

    const formData = new FormData();

    Object.entries(payload).forEach(([key,value])=>{
      formData.append(key,value);
    });

    const res1 = await fetch(SCRIPT_URL,{
      method:"POST",
      body: formData
    });

    if(!res1.ok){
      throw new Error("Erro ao registrar pedido.");
    }

    const res2 = await fetch(CLOUD_RUN_URL,{
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        description,
        preco,
        compra_id: compraId
      })
    });

    if(!res2.ok){
      throw new Error("Erro ao gerar pagamento.");
    }

    const data = await res2.json();

    if(!data.checkout){
      throw new Error("URL de pagamento inválida.");
    }

    window.location.href = data.checkout;

  } catch(err){

    console.error(err);

    setError("Não foi possível iniciar o pagamento. Tente novamente.");

    setSubmitting(false);

  }

}

  if (!kit || !preco) {
    return (
      <div className="checkout-container">
        <div className="checkout-card">
          <h2>Selecione um produto para efetuar a compra</h2>

          <Link to="/" className="back-button">
            Voltar para produtos
          </Link>
        </div>
      </div>
    );
  }

  return(

    <div className="checkout-container">

      <div className="progress">
        <div className="progress-bar"/>
      </div>

      <form className="checkout-card">

        <h2>Finalizar pedido - {description} - R$ {preco}</h2>

        <input name="nome" placeholder="Nome completo" onChange={handleChange} required />
        <input name="celular" type="tel" inputMode="numeric" placeholder="Celular (DDD) 99999-1111" value={form.celular} onChange={handleChange} required />

        <div className="row">

          <input name="cep" placeholder="CEP" value={form.cep} onChange={handleChange} required />
          <input name="numero" placeholder="Número" onChange={handleChange} required />

        </div>

        {loadingCep && <span className="loading">Buscando endereço...</span>}

        <input name="endereco" placeholder="Endereço" value={form.endereco} onChange={handleChange} required />
        <input name="bairro" placeholder="Bairro" value={form.bairro} onChange={handleChange} required />

        <div className="row">

          <input name="cidade" placeholder="Cidade" value={form.cidade} onChange={handleChange} required />

          <select name="estado" value={form.estado} onChange={handleChange} required>

            <option value="">Estado</option>

            {estados.map(uf=>(
              <option key={uf} value={uf}>{uf}</option>
            ))}

          </select>

        </div>

        <input name="email" type="email" placeholder="Email" onChange={handleChange} required />
        <input name="cpf" placeholder="CPF" onChange={handleChange} required />

        {error && (
          <div className="error-box">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={handleSubmit}
          disabled={submitting}
          className={submitting ? "loading-btn" : ""}
        >

        {submitting ? (
          <>
            <span className="spinner"></span>
            Gerando pagamento...
          </>
        ) : (
          "Continuar para pagamento"
        )}

        </button>

      </form>

    </div>
  )
}